export const DROPDOWN_MAX_HEIGHT = 160;
export const MENU_ITEM_HEIGHT = 40;
export const MIN_SEARCH_LENGTH = 3;
export const DEBOUNCE_TIME = 500;
export const NEW_DROPDOWN_MAX_HEIGHT = 200;
